module.exports = __webpack_public_path__ + "img/bg-more.5dda8b4c.png";